export default "__VITE_ASSET__BTcq84Do__"